<template>
  <div>
    <vs-table :data="arrayInformation" stripe  max-items="2" search pagination>
      <template slot="thead">
        <vs-th>#</vs-th>
        <vs-th>Datos</vs-th>
        <vs-th>Observación</vs-th>
        <vs-th>Valores</vs-th>
        <vs-th>Años</vs-th>
        <vs-th>Acciones</vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>{{ tr.id }}</vs-td>
          <vs-td :data="tr.email">
            <b>Institución:</b>
            <p>{{ tr.nombreInstitucion }}</p>
            <b>Período:</b>
            <p>{{ tr.periodo }}</p>
            <b v-if="tr.convenio_aprobado > 0">Estado valor Global:</b>
            <!-- <p v-if="tr.convenio_aprobado == 0">Convenio aprobado facturador</p> -->
            <p v-if="tr.convenio_aprobado == 1" class="font-bold text-warning">Convenio solicitado a gerencia ${{ tr.valor_sugerido }} </p>
            <p v-if="tr.convenio_aprobado == 2" class="text-danger">Convenio anulado por  gerencia ${{ tr.valor_sugerido }} </p>
            <p v-if="tr.convenio_aprobado == 3" class="font-bold text-success">Convenio solicitado a gerencia aprobado ${{ tr.valor_aprobado_gerencia }} </p>
            <div v-if="tr.estado == 2">
              <b>Cerrado por:</b>
              <p>{{ tr.usuario_cierre}}</p>
            </div>
            <b>Estado convenio:</b>
            <p>
              <div v-if="tr.estado == 2">
                <vs-chip color="danger" v-if="tr.estado == 2">Cerrado</vs-chip>
              </div>
              <vs-chip color="warning" v-if="tr.estado == 1">En curso</vs-chip>
              <vs-chip color="success" v-if="tr.estado == 0">Finalizado</vs-chip>
            </p>

            <br><br>
            <div v-if="tr.usuario_creador">
              <b>Creado por:</b>
              <p>{{ tr.usuario_creador }}</p>
              <b>Fecha creación:</b>
              <p>{{ tr.created_at }}</p>
            </div>
            <!--AUTORIZACION-->
            <div v-if="tr.estado_solicitud_convenio_cerrado == 1">
              <b class="font-bold text-danger"><i class="fa-solid fa-flag"></i> POR AUTORIZAR GERENCIA POR CONVENIO CERRADO</b>
            </div>
            <div v-if="tr.estado_solicitud_convenio_cerrado == 2">
              <b>Valor global creado por:</b>
              <p> {{tr.valor_global_inicial}}</p>
              <b>Autorizado por:</b>
              <p>Gerencia</p>
              <!-- <b class="font-bold text-success"><i class="fa-solid fa-flag"></i> Convenio que fue cerrado Autorizado por gerencia por ${{tr.cantidad_finalizada}}</b> -->
            </div>
            <!--APROBACION POR FACTURADOR-->
            <div v-if="tr.estado_aprobado_convenio_cerrado == 1" class="mt-2">
              <b class="font-bold text-danger"><i class="fa-solid fa-triangle-exclamation"></i> POR APROBAR POR ADMIN FACTURADOR (Tiene que aprobar para que los facturadores puedan ver el pedido)</b>
              <vs-button @click="convenioSelect=tr;confirmAprobarConvenioCerrado();" v-if="userAdminFacturador || userRoot" color="danger" type="border" class="m-2"><i class="fa-solid fa-radiation"></i> Aprobar Convenio cerrado</vs-button>
            </div>
            <div v-if="tr.estado_aprobado_convenio_cerrado == 2" class="mt-2">
              <b>Aprobador por:</b>
              <p>Facturador Admin</p>
              <!-- <b class="font-bold text-success"><i class="fa-solid fa-flag"></i> Convenio que fue cerrado Aprobado por Facturador Admin</b> -->
            </div>
          </vs-td>
          <vs-td :data="tr.observacion">
            {{ tr.observacion }}
            <template slot="edit" v-if="groupFacturador && tr.estado == 1">
              <vs-input v-model="tr.observacion" class="inputx" placeholder="Observación" @keyup.enter="convenioSelect=tr;updateValor('observacion',tr.observacion)"/>
              <vs-button radius color="success" @click="convenioSelect=tr;updateValor('observacion',tr.observacion)"  style="position: relative;left:20px;top:10px;" type="gradient" icon="save"></vs-button>
            </template>
          </vs-td>
          <vs-td :data="tr.anticipo_global">
            <b>Anticipo Global:</b>
            <p>{{ tr.anticipo_global }}</p>
            <div v-if="tr.estado == 2">
              <b>Valor convenio pagado pagado</b>
              <p>{{ tr.valor_convenio_pagado }}</p>
              <b>Deuda que termina el convenio</b>
              <p v-if="tr.deuda_convenio > 0" class="text-danger font-bold">{{ tr.deuda_convenio }}</p>
              <p v-else>{{ tr.deuda_convenio }}</p>
            </div>
            <!-- <template slot="edit" v-if="groupFacturador && tr.estado == 1">
              <vs-input v-model="tr.anticipo_global" class="inputx" placeholder="Anticipo global" @keyup.enter="convenioSelect=tr;updateValor('anticipo_global',tr.anticipo_global)"/>
              <vs-button radius color="success" @click="convenioSelect=tr;updateValor('anticipo_global',tr.anticipo_global)"  style="position: relative;left:20px;top:10px;" type="gradient" icon="save"></vs-button>
            </template> -->
          </vs-td>
          <vs-td :data="tr.convenio_anios">
            <p>{{ tr.convenio_anios }}</p>
            <template slot="edit" v-if="groupFacturador && tr.estado == 1">
              <vs-input type="number" v-model="tr.convenio_anios" class="inputx" placeholder="Años convenios" @keyup.enter="convenioSelect=tr;updateValor('convenio_anios',tr.convenio_anios)"/>
              <vs-button radius color="success" @click="convenioSelect=tr;updateValor('convenio_anios',tr.convenio_anios)"  style="position: relative;left:20px;top:0px;" type="gradient" icon="save"></vs-button>
            </template>
          </vs-td>
          <vs-td>
            <vx-tooltip v-if="groupFacturador && tr.estado == 1 && tr.estado_solicitud_convenio_cerrado != 1"  text="Solicitar más Convenio" position="top" color="warning" style="display: inline-block; z-index: 3;">
                <vs-button class="m-2" @click="id=tr.doc_codigo;convenioSelect=tr;popupConfirmConvenioAprobado=true;" icon-pack="feather" icon="icon-check" color="success" type="gradient">{{ tr.convenio_aprobado == 3 ? 'Aprobar o Solicitar más convenio' :'Aprobar o Solicitar más convenio'}} </vs-button>
              </vx-tooltip>
            <vs-button class="ml-3" v-if="groupFacturador && tr.estado == 1 && tr.estado_solicitud_convenio_cerrado != 1" @click="convenioSelect=tr;confirmCerrarConvenio();">
              <i class="fa-regular fa-rectangle-xmark"></i>  <span class="ml-1"> Cerrar contrato</span>
            </vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <!--modales-->
    <vs-popup classContent="popup-example" title="Aprobar Convenio Global" :active.sync="popupConfirmConvenioAprobado">
      <AprobarAnticipoAprobadoVue v-if="popupConfirmConvenioAprobado" ifconvenio="1" :sendConvenio="convenioSelect" :sendPedido="sendPedido" :usuario="usuario" :userRoot="Boolean(userRoot)" @changeHandle="changeHandle"/>
    </vs-popup>
  </div>
</template>
<script>
  import {
    mapState
} from "vuex";
const AprobarAnticipoAprobadoVue = () => import('../../../../../pedidos2/pedidos/anticipos/pagos2/components/AprobarAnticipoAprobado.vue')
export default {
  components:{
      AprobarAnticipoAprobadoVue,
    },
  data(){
    return{
      convenioSelect:'',
      popupConfirmConvenioAprobado:false,
    }
  },
  props:{
    usuario:{
      type:Object,
      default:function(){
        return {}
      }
    },
    idConvenio:{
      type:Number,
      default:0,
    },
    arrayInformation:{
      type:Array,
      default:function(){
        return []
      }
    },
    groupFacturador:{
      type:Boolean,
      default:false
    },
    userRoot:{
      type:Boolean,
      default:false
    },
    sendPedido:{
      type:Object,
      default:function(){
        return {}
      }
    }
  },
  watch:{
    arrayInformation(results){
      this.arrayInformation = results
    }
  },
  computed:{
    ...mapState(['userAdminFacturador']),
  },
  methods:{
    changeHandle(e){
      let me = this
      if(e == 0) { me.popupConfirmConvenioAprobado = false; }
      if(e == 1) { me.popupConfirmConvenioAprobado = false;  me.$emit('changeRecharge',1) }
    },
    updateValor(campo,valor){
      let me = this;
      if(campo == 'convenio_anios'){
        if( valor < 2 ){
          me.$emit('changeRecharge',3)
          $(".content-tr-expand").hide()
          me.$vs.notify({
          text:'El convenio no puede ser menor a 2 años',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return
        }
      }
      if(campo == 'anticipo_global'){
        //validacion anticipo global
        if(valor < 0 || valor == "" || valor == null){
          me.$emit('changeRecharge',3)
          $(".content-tr-expand").hide()
          me.$vs.notify({
          text:'El convenio global no puede ser menor a 0',
          color:'warning',
          iconPack: 'feather',
          icon:'icon-check'})
          return
        }
      }
      let formData = new FormData();
      formData.append('updateCamposDatos',    'yes')
      formData.append('unCampo',              'yes')
      formData.append('id',                   me.convenioSelect.id);
      formData.append('campo1',               campo);
      formData.append('valor1',               valor)
      formData.append('user_created',         me.usuario.idusuario)
      formData.append('idConvenio',          me.convenioSelect.id)
      this.$http.post(this.$server_url+'convenio', formData)
      .then(res => {
        if(res.data.status == 0){
          me.$emit('changeRecharge',1)
          $(".content-tr-expand").hide()
          me.$vs.notify({
          text:res.data.message,
          color:'danger',
          iconPack: 'feather',
          icon:'icon-check'})
          return
        }
        me.$emit('changeRecharge',3)
        $(".content-tr-expand").hide()
        me.$vs.notify({
          text:'Se guardo con éxito',
          color:'success',
          iconPack: 'feather',
          icon:'icon-check'})
          $(".content-tr-expand").hide()
      })
      .catch((e)=>{
        // me.$vs.loading.close()
      })
    },
    //metodos para cerrar convenio
    confirmCerrarConvenio(){
      let me = this
      me.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Cerrar convenio',
        text: '¿Está seguro que desea cerrar el convenio?',
        acceptText: 'Aceptar',
        cancelText:'Cancelar',
        accept: me.cerrarConvenio,
        cancel: false
      })
    },
    cerrarConvenio(){
      let me = this
      let formData = new FormData();
      formData.append('cerrarConvenio',   '1')
      formData.append('idConvenio',        me.convenioSelect.id);
      formData.append('user_created',      me.usuario.idusuario);
      formData.append('contrato',          me.sendPedido.contrato_generado)
      formData.append('id_pedido',         me.sendPedido.id_pedido)
      me.$vs.loading()
      this.$http.post(this.$server_url+'convenio', formData)
      .then(res => {
      me.$vs.loading.close()
      if(res.data.status == 0){
        me.$vs.notify({
        text:res.data.message,
        color:'danger',
        iconPack: 'feather',
        time:4000,
        icon:'icon-check'})
        return
      }
      me.$vs.notify({
        text:res.data.message,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check'})
      })
      me.$emit('changeRecharge',4)
    },
    confirmAprobarConvenioCerrado(){
      let me = this
      me.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Aprobar convenio cerrado',
        text: '¿Está seguro que desea aprobar el convenio cerrado?',
        acceptText: 'Aceptar',
        cancelText:'Cancelar',
        accept: me.aprobarConvenioCerrado,
        cancel: false
      })
    },
    aprobarConvenioCerrado(){
      let me = this
      let formData = new FormData();
      formData.append('aprobarConvenioCerrado',   '1')
      formData.append('idConvenio',               me.convenioSelect.id);
      formData.append('user_created',             me.usuario.idusuario);
      formData.append('contrato',                 me.sendPedido.contrato_generado)
      formData.append('id_pedido',                me.sendPedido.id_pedido)
      me.$vs.loading()
      this.$http.post(this.$server_url+'convenio', formData)
      .then(res => {
      me.$vs.loading.close()
      if(res.data.status == 0){
        me.$vs.notify({
        text:res.data.message,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check'})
        return
      }
      me.$vs.notify({
        text:res.data.message,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check'})
      })
      me.$emit('changeRecharge',4)
    }
    //fin metodos para cerrar convenio
  }
}
</script>
